<template>
  <div class="introdction">
    <div class="base-son-title-txt">
      <div class="line"/>
      <div class="txt-1 txt-1-1">App Introduction</div>
      <div class="base-son-title-txt1">
        <p class="txt-2">无极机车APP</p>
        <img src="@/assets/xia.png" alt="">
        <p class="txt-3 txt-1-1">简介</p>
      </div>
    </div>
    <div class="text-1">无极机车作为无极摩托车配套APP，可为隆鑫无极摩托车主提供爱车信息查看（如历史轨迹、驾驶行为、车辆位置等）、车控（固件升级、闪灯鸣笛等）、服务（如保养手册、保养视频、门店查询等）、摩圈、商城等功能，为车主提供相应的服务！
    </div>
    <div class="app-link" @click="onLink">无极机车app下载</div>
    <div class="back-home" @click="onGoHome">回到首页</div>
  </div>
</template>

<script>
  export default {
    name: 'Pdf',
    components: {

    },
    data() {
      return {
        perviewUrl: '',
        width: '',
        height: '',
      }
    },
    created() {
      document.title = '无极机车APP简介'
      this.width = 1200
      this.height = 2148
    },
    methods: {
      onLink(){
        window.location.href = 'https://lsts.loncinindustries.com/iotapp/download.html'
      },
      onGoHome() {
        window.location.href = 'https://vogemotor.com/'
      },
    }
  }
</script>

<style lang="scss" scoped>
  .introdction {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: url("./assets/img/brand-culture/brand-culture.jpg") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .base-son-title-txt{
      .line{
        background-color: #facc0a;
        width: 90px;
        height: 5px;
        border-radius: 10px;
        margin: 0 auto 20px;
      }
      .txt-1-1 {
        color: white
      }
      .txt-1{
        font-size: 2.5vh;
        margin-bottom: 10px;
        text-align: center;
      }
      .base-son-title-txt1{
        display: flex;
        justify-content: center;
        margin: 0 auto;
        line-height: 30px;
        .txt-2,.txt-3{
          font-size: 3vh;
          padding: 0 10px;
        }
        .txt-2 {
          color: #FBCC0A;
        }
        img{
          width: 30px;
        }
      }
    }
    .text-1{
      margin-top: 2vh;
      width:1200px;
      font-size:2.5vh;
      text-align:center;
      word-wrap:break-word;
      word-break:break-all;
      color:white
    }
    .app-link{
      border-radius: 2px;
      padding: 2px 5px;
      position: absolute;
      right: 1vw;
      top: 1vh;
      background-color: rgba(248, 240, 80, 0.5);
      color: white;
      cursor: pointer;
      font-size: 2vh;
    }
    .back-home{
      position: absolute;
      top: 1vh;
      left: 1vw;
      color: white;
      font-size: 2vh;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/introduction.vue